import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { getSocialProviderText } from "@faire/retailer-visitor-shared/lib/ssoUtils";
import { useSSOStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOStore";
import { Button } from "@faire/web--source/slate/Button";
import { Apple } from "@faire/web--source/slate/icons/external/Apple";
import { Google } from "@faire/web--source/slate/icons/external/Google";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { GrowingSpacer, Spacer } from "@faire/web--source/slate/spacing";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackSigninSsoClick } from "@faire/web-api--source/events/signin/click/sso";
import { SocialSignOnProvider } from "@faire/web-api--source/indigofair/data/SocialSignOnProvider";
import React from "react";
import styled from "styled-components";
export var BaseSocialLoginButton = function(props) {
    var disabled = props.disabled, loading = props.loading, socialProvider = props.socialProvider, onClick = props.onClick, isOnSignIn = props.isOnSignIn, sourceId = props.sourceId;
    var recordSSOButtonClick = useSSOStore().recordSSOButtonClick;
    var icon = null;
    switch(socialProvider){
        case SocialSignOnProvider.GOOGLE:
            icon = /*#__PURE__*/ _jsx(StyledGoogleIcon, {
                fontSize: "20px",
                $disabled: disabled
            });
            break;
        case SocialSignOnProvider.OKTA:
            // TODO (FD-227733): Change to StyledOktaIcon once added
            icon = /*#__PURE__*/ _jsx("img", {
                className: "oktaIcon",
                title: "Okta logo",
                src: "https://cdn.faire.com/fastly/467172fbeba306a9dc5696feb65261ea823ecd289aca5df68b8ffca1d1441449.png",
                style: {
                    height: "40px",
                    width: "40px"
                }
            });
            break;
        case SocialSignOnProvider.APPLE:
            icon = /*#__PURE__*/ _jsx(StyledAppleIcon, {
                fontSize: "20px",
                $disabled: disabled
            });
            break;
        default:
            break;
    }
    return /*#__PURE__*/ _jsxs(StyledButton, {
        disabled: disabled,
        loading: loading,
        variant: "secondary",
        onClick: function() {
            recordSSOButtonClick();
            trackSigninSsoClick(socialProvider, sourceId);
            onClick === null || onClick === void 0 ? void 0 : onClick();
        },
        children: [
            icon,
            /*#__PURE__*/ _jsx(GrowingSpacer, {}),
            isOnSignIn ? /*#__PURE__*/ _jsx(SignInCopy, {
                socialProvider: socialProvider
            }) : /*#__PURE__*/ _jsx(SignupCopy, {
                socialProvider: socialProvider
            }),
            /*#__PURE__*/ _jsx(GrowingSpacer, {}),
            /*#__PURE__*/ _jsx(Spacer, {
                width: "3x"
            })
        ]
    });
};
var SignInCopy = function(param) {
    var socialProvider = param.socialProvider;
    return /*#__PURE__*/ _jsx(StrictLocalMsg, {
        id: "hFeXVj",
        defaultMessage: [
            {
                type: 0,
                value: "Sign in with "
            },
            {
                type: 1,
                value: "socialProviderCompanyName"
            }
        ],
        values: {
            socialProviderCompanyName: getSocialProviderText(socialProvider)
        }
    });
};
var SignupCopy = function(param) {
    var socialProvider = param.socialProvider;
    return /*#__PURE__*/ _jsx(StrictLocalMsg, {
        id: "zaAT+X",
        defaultMessage: [
            {
                type: 0,
                value: "Sign up with "
            },
            {
                type: 1,
                value: "socialProviderCompanyName"
            }
        ],
        values: {
            socialProviderCompanyName: getSocialProviderText(socialProvider)
        }
    });
};
var StyledButton = styled(Button).withConfig({
    componentId: "sc-4bd6c11c-0"
})([
    "border:1px solid ",
    ";padding:",
    ";width:100%;&:hover{img.oktaIcon{filter:invert(1);}}"
], Core.border.muted, getSpacing(0, "3x"));
var StyledAppleIcon = styled(Apple).withConfig({
    componentId: "sc-4bd6c11c-1"
})([
    "",
    ""
], function(props) {
    return props.$disabled ? "opacity: 0.5;" : "";
});
var StyledGoogleIcon = styled(Google).withConfig({
    componentId: "sc-4bd6c11c-2"
})([
    "",
    ""
], function(props) {
    return props.$disabled ? "opacity: 0.5;" : "";
});
